export function PlayerSilhouette({ className = "" }) {
  return (
    <svg
      viewBox="0 0 200 220"
      className={className}
      preserveAspectRatio="xMidYMax meet"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="sil" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0F3E7F" />
          <stop offset="100%" stopColor="#08234E" />
        </linearGradient>
      </defs>
      <rect width="200" height="220" fill="url(#sil)" />
      <g fill="#0b2f63">
        <circle cx="100" cy="78" r="42" />
        <path d="M28 220c0-46 32-74 72-74s72 28 72 74z" />
      </g>
    </svg>
  );
}
